import styles from './index.module.scss';

type Props = {
  color: string;
};

export const ColorBodyCell = ({ color }: Props) => {
  return <div style={{ backgroundColor: color }} className={styles.colorBlock} />;
};
